import React, { useEffect, useState } from "react";
import "../style/form/AppoinmentReschedule.scss";
import { appoinmentrescheduleapi } from "../../text/apidata";
import axios from "axios";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimeField } from "@mui/x-date-pickers/TimeField";
import { SingleInputTimeRangeField } from "@mui/x-date-pickers-pro/SingleInputTimeRangeField";
import { useDispatch, useSelector } from "react-redux";
import Button from "@mui/material/Button";
import { basetimeedit, appoinmentreshedule, appoinmentresheduleid } from "../redux/reducer/counterslice";
import Swal from "sweetalert2";
import { DatePicker, Stack } from "rsuite";

import isBefore from 'date-fns/isBefore';

function AppoinmentReschedule(props) {


  const [alert, setalert] = useState(false);
  const [productvalue, setproductvalue] = useState({
    visit_date: "",
    visit_slot: "",
  });
  const [range, setrange] = useState();
  const [createddate, setcreateddata] = useState()

  const appoinmentresheduleidstate = useSelector(
    (state) => state.counter.appoinmentresheduleid
  );

  const dispatch = useDispatch();
  // console.log(duration);
  const routehead = useNavigate();

  const cancelnewuser = () => {
    if (alert) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, revert it!",
      }).then((result) => {
        if (result.isConfirmed) {
          //Swal.fire("Reverted!", "Given Info has been Removed.", "success");
          dispatch(appoinmentreshedule(""));
          setalert(false);
        }
      });
    } else {
      dispatch(appoinmentreshedule(""));
      dispatch(appoinmentresheduleid(""))

      setalert(false);
    }
  };

  const handlechangedate = (name, value, timeString) => {
    setalert(true);
    console.log(name, value, timeString)
    if ((name = "delivery_date")) {
      if (value != null) {
        setrange((oldArray) => [
          ...oldArray,
          value.slice(0, 10) + " " + String(timeString).slice(0, 8),
        ]);
      }
      var dateTimeString = value;
      var dateTime = new Date(dateTimeString);
      var hours = dateTime.getHours();
      var minutes = dateTime.getMinutes();
      var seconds = dateTime.getSeconds();

      // Format the time as a string
      var timeString = hours + ":" + minutes + ":" + seconds;

      console.log(timeString);
      setproductvalue({
        ...productvalue,
        visit_date: value.slice(0, 10),
        visit_slot: timeString
      });
    }
  };


  const cleaningrange = () => {
    setproductvalue({
      ...productvalue,
      visit_date: "",
      visit_slot: ""
    });

    setrange([]);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
  };
  console.log(appoinmentresheduleidstate)
  const newusercreate = () => {
    axios({
      method: "put",
      url: appoinmentrescheduleapi + appoinmentresheduleidstate + "/",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token") + "",
      },
      data: productvalue
    })
      .then((res) => {
        dispatch(appoinmentreshedule(""));
        dispatch(appoinmentresheduleid(""))

        props.loaderchange("false");
        props.popupalert("true");
        props.popuptext("Appoinment Reschedule Successfully");
        setTimeout(() => {
          props.popupalert("false");
        }, 2000);
      })
      .catch((error) => {
        console.log(error);
        props.loaderchange("false");
        // setdtPageindex(dtpageindex-1)
        // console.log(dtpageindex)
        props.popupalert("true");
        props.popuptext("No Data Available");
        setTimeout(() => {
          props.popupalert("false");
        }, 2000);
      });
  }
  return (
    <>
      <div className="adminform">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content1">
            <div class="modal-header">
              <h5 class="modal-title">
                Appoinment Reschedule
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => cancelnewuser(e)}
              >
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
            <div class="modal-body">
              <div className="maincontainer-BaseTimeForm">
                <div className="parent-BaseTimeForm">
                  <div className="create-BaseTimeForm card">
                    <form
                      style={{ padding: "0rem 0rem 0rem 0rem" }}
                      className="formspace"
                      onSubmit={handleSubmit}
                    >
                      <div class="form-group col-md-12 p-1 m-0 datepic">
                        <label for="validationCustom04" class="form-label">
                          Reschedule Date
                        </label>
                        <DatePicker
                          format="yyyy-MM-dd HH:mm:ss"
                          showMeridian
                          style={{ width: "100%" }}
                          placement="rightEnd"
                          size="lg"
                          value={
                            range != "" &&
                              range != null &&
                              range != undefined
                              ? new Date(range)
                              : null
                          }
                          disabledDate={date => isBefore(date, new Date(createddate))}

                          onClean={(e) => cleaningrange(e)}
                          onChange={(e) => {
                            if (e != null) {
                              setrange([]);
                              console.log(e);
                              const date = new Date(e);

                              const timeString = date.toLocaleTimeString("en-US", {
                                timeStyle: "medium",
                              });
                              var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                              var localISOTime = new Date(e - tzoffset)
                                .toISOString()
                                .slice(0, -1);
                              handlechangedate(
                                "delivery_date",
                                localISOTime,
                                timeString
                              );
                            }
                          }}
                        />
                        <p style={{ fontSize: "12px", color: "red" }}>
                          {/* {dateer ? "Date Time  Required" : ""} */}
                        </p>
                      </div>
                      <div
                        class="form-row"
                        style={{
                          display: "flex",
                          flexFlow: "row wrap",
                          placeContent: "center space-between",
                          alignItems: "center",
                        }}
                      >
                        <div class="form-group col-md-12 pb-3 pt-4 m-0">
                          <button
                            type="submit"
                            class="btn btn-primary  create"
                            onClick={(e) => newusercreate(e)}
                            disabled={!alert ? true : false}
                          >
                            Update Appoinment Reschedule
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AppoinmentReschedule;
